module.exports = __webpack_public_path__ + "static/media/ANNUAL STAKEHOLDER 31_3.3b505c8e.jpg";